/**
 * Language preselection rules based on marketplace
 *
 * Marketplace: https://w.amazon.com/bin/view/MarketplaceID
 * Language codes: https://docs.aws.amazon.com/translate/latest/dg/what-is-languages.html
 */

// Direct marketplace  to language mapping
export const MARKETPLACE_LANGUAGE_RULES: Record<string, string[]> = {
    // Americas
    US: ["EN"],
    CA: ["EN", "FR"], // English + French
    BR: ["EN", "PT"], // English + Portuguese
    MX: ["EN", "ES"], // English + Spanish
    CO: ["EN", "ES"], // English + Spanish
    CL: ["EN", "ES"], // English + Spanish

    // Europe
    UK: ["EN"],
    DE: ["EN", "DE"], // English + German
    FR: ["EN", "FR"], // English + French
    IT: ["EN", "IT"], // English + Italian
    ES: ["EN", "ES"], // English + Spanish
    NL: ["EN", "NL"], // English + Dutch
    PL: ["EN", "PL"], // English + Polish
    SE: ["EN", "SV"], // English + Swedish
    BE: ["EN", "NL", "FR"], // English + Dutch + French
    IE: ["EN"],
    RU: ["EN"],

    // Asia Pacific
    JP: ["EN", "JA"], // English + Japanese
    CN: ["EN", "ZH"], // English + Chinese
    AU: ["EN"],
    SG: ["EN"],
    IN: ["EN", "HI"], // English + Hindi
    TH: ["EN", "TH"], // English + Thai
    ID: ["EN"],

    // Middle East & Africa
    AE: ["EN", "AR"], // English + Arabic
    SA: ["EN", "AR"], // English + Arabic
    TR: ["EN", "TR"], // English + Turkish
    EG: ["EN", "AR"], // English + Arabic
    ZA: ["EN"],
    NG: ["EN"],
};

/**
 * Get the languages that should be preselected for a given country
 */
export const getLanguagesForCountry = (countryCode: string): string[] => {
    return MARKETPLACE_LANGUAGE_RULES[countryCode] || ["EN"];
};
